import { render, staticRenderFns } from "./DeleteEmployee.vue?vue&type=template&id=1d1655eb"
import script from "./DeleteEmployee.vue?vue&type=script&lang=js"
export * from "./DeleteEmployee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports